import { useModalContext } from '../../contexts/ModalContext'
import EditIconButton from '../parts/button/EditIconButton'
import ExitIconButton from '../parts/button/ExitIconButton'

const ModalHeader = ({ img = [null, "Pas d'image"] }) => {

    const { modalState } = useModalContext()

    const h2Title = modalState?.modalType === "profile" ? "Mes informations :" : modalState?.wishData?.title

    return (
        <header className='flex flex-col gap-4'>
            <div className="relative bg-ivory flexJustifyItemsCenter rounded-md shadow-md">
                <EditIconButton />
                <img className="h-[14vh] m-3 rounded-full cursor-pointer hover:brightness-110 sm:h-[17vh]" src={img[0]} alt={img[1]} />
                <ExitIconButton />
            </div>
            <div className="shadow-md shadow-darkRed rounded-md">
                <h2 className="p-3 bg-darkRed rounded-md text-ivory text-center font-bold shadow-inner shadow-ivory">{h2Title}</h2>
            </div>
        </header>
    )
}

export default ModalHeader